import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { environment } from '../environment/environment';
import TokenService from './token.service'; // Assuming you have a TokenService that handles token parsing
import { TokenPayload } from '../models/IToken';

class TerminateService {
  private static instance: TerminateService;

  private constructor() {}

  public static getInstance(): TerminateService {
    if (!TerminateService.instance) {
      TerminateService.instance = new TerminateService();
    }
    return TerminateService.instance;
  }

  public terminateSession = async (): Promise<void> => {
    try {
      // Parse the token to get the room ID
      let parsedToken: TokenPayload = TokenService.parseToken(true, "");
      const roomId = parsedToken.video.room; 

      const axiosConfig: AxiosRequestConfig = {
        headers: {
          'TenantAlias':  environment.tenantAlias,
          'Authorization': `Bearer ${TokenService.getToken()}`
        },
      };

      // Send the request to terminate the session
     await axios.post(`${environment.controlServerEndpoint}/session/${roomId}/terminate`,{},axiosConfig);

      return;
    } catch (error) {
      console.error('Error terminating session:', error);
      throw error;
    }
  };
}

export default TerminateService.getInstance();
